import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import DetailCarouselCard from './DetailCarouselCard';
import { useTranslation } from 'react-i18next';

const DetailCarousel = ({ clips }) => {
  const { t } = useTranslation();

  return (
    <div className={'detail-carousel-all-wrapper'}>
      <h3 className={'detail-carousel-title'}>{t('provided_video')}</h3>
      <div className='detail-carousel-card-wrapper'>
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={2}
          spaceBetween={32}
          navigation
          speed={500}
          loop={false}
          breakpoints={{
            321: {
              spaceBetween: 10,
              slidesPerView: 2.1,
            },
            721: {
              spaceBetween: 20,
            },
            1025: {
              spaceBetween: 32,
            },
          }}
        >
          {clips?.map((item, index) => (
            <SwiperSlide key={index}>
              <DetailCarouselCard item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default DetailCarousel;
